import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog } from "components/TimelineLogs";

function useLogsAreaComum(
  tenantId: string | undefined,
  id: string | undefined
) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${id}/logs`,
    async () => {
      const { data } = await axios.get<TimelineLog[]>(
        `/v1/tenants/${tenantId}/area-comum/${id}/logs`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsAreaComum;
